import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';

export const generateToken = (callback?: (result: any, error: any) => void): actionsInterfaces.IGetTokeAction => {
  return {
    type: actionsTypes.GET_TOKEN,
    callback
  };
};

export const uploadFile = (file: actionsInterfaces.IFile, token: string | undefined, callback: IAsyncActionCallback): actionsInterfaces.IUploadFileAction => {
  return {
    type: actionsTypes.UPLOAD_FILE,
    file,
    token,
    callback
  };
};

export const duplicateFile = (duplicateFileData: actionsInterfaces.IDuplicateFileData, callback: IAsyncActionCallback): actionsInterfaces.IDuplicateFileAction => {
  return {
    type: actionsTypes.DUPLICATE_FILE,
    duplicateFileData,
    callback
  };
};

export const addSucceededFile = (response: {})=> {
  return {
    type: actionsTypes.ADD_SUCCEEDED_FILE,
    response,
  };
};

export const setToken = (token: string): actionsInterfaces.ISetTokenAction => {
  return {
    type: actionsTypes.SET_TOKEN,
    token,
  };
};